export default (editor, opts = {}) => {
  const cmd = editor.Commands;
  const { commands } = opts;

  cmd.add(commands.ddt_custom_code, {
    run(editor, sender, opts = {}) {
      const event = opts && opts.event;
      const { target } = opts;
      const sel = target || editor.getSelected();

      const clientX = event.clientX;
      const clientY = event.clientY;
      const tm = editor.TraitManager;
      const tmView = tm.getTraitsViewer();

      editor.Popover.open({
        title: 'Configure Component',
        content: tmView.render().el,
      })
        .getModel()
        .once('change:open');
    },
  });
};
